import type {
  GridColDef,
  GridRenderCellParams,
  GridRowModel,
} from '@mui/x-data-grid-pro';

import ActionColumn from './ActionColumn';
import InRowEditActionColumn from './InRowEditActionColumn';

export interface ExtraActionBtn {
  disabled?: boolean;
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
}

export interface ActionColumnProps<TRow extends GridRowModel> {
  extraActions?: (row: TRow) => ExtraActionBtn[];
  cellClassName?: GridColDef<TRow>['cellClassName'];
  readActionConfig?: {
    readHiddenForRow?: (row: TRow) => boolean;
    onClick?: (id: string, row: TRow) => void;
  };
  changeActiveDisabledForRow?: (row: TRow) => boolean;
  onChangeActiveStatus?: (id: string, isActive: boolean) => void;
  deleteDisabledForRow?: (row: TRow) => boolean;
  onDeleteClick?: (id: string) => void;
}

export interface InRowEditActionColumnProps<TRow extends GridRowModel> {
  inRowEditConfig: (row: TRow) => {
    editHiddenForRow?: boolean;
    isEditDisabled?: boolean;
    isDeleteDisabled?: boolean;
    onSaveClick?: () => boolean | void;
    onDeleteClick?: () => void;
    onCancelClick?: () => void;
    overrideEditBtn?: () => void;
    useEditIcon?: boolean;
  };
}

const addActionColumnProps = <TRow extends GridRowModel>(
  actionColumnProps: ActionColumnProps<TRow> & InRowEditActionColumnProps<TRow>,
): GridColDef<TRow> => {
  return {
    field: 'actions',
    type: 'actions',
    cellClassName: actionColumnProps?.cellClassName,
    width: 85,
    renderCell: (params: GridRenderCellParams<TRow>) =>
      actionColumnProps?.inRowEditConfig ? (
        <InRowEditActionColumn
          {...(actionColumnProps as InRowEditActionColumnProps<TRow>)}
          params={params}
        />
      ) : (
        <ActionColumn
          {...(actionColumnProps as ActionColumnProps<TRow>)}
          params={params}
        />
      ),
  };
};

export default addActionColumnProps;
